import { PageType } from '@gumtree/shared/src/types/client-data';

export const doesPrebidExistOnPage = (pageType: PageType) =>
    (['Homepage', 'ResultsBrowse', 'ResultsSearch', 'VIP'] as PageType[]).includes(pageType);
